'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'How Create Electronic Signature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'How Do I Create An Electronic Signature?',
            subtitle: 'Ready to jump in and start signing?',
            buttonText: 'CREATE YOUR FREE ACCOUNT'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'How do I create an electronic signature?'), _jsx('p', {}, void 0, 'You can create your electronic signature in a few different ways. Each signature takes only a few clicks or swipes and will be stored in your HelloSign account for future signing. Here are your options:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Draw your signature using your finger or a stylus.'), ' If you have access to a touchscreen, you can use your finger to create an electronic signature directly in your document. This is particularly helpful for when you’re signing on a mobile device or tablet!'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Upload an image of your signature.'), ' Use your phone or camera to take a picture of your paper signature. Once it’s uploaded into your HelloSign account, it will be turned into a .png file that overlays neatly over the signature line in your document.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Use your cursor to draw your signature.'), ' Using your mouse or your touchpad, you can drag your cursor along the signature line to create a unique electronic signature.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Use your keyboard to type in your signature.'), ' This is the easiest way to create your electronic signature. Once you’ve typed in your name, you can select a font that best matches your paper signature.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'Is an electronic signature as legal as a paper signature?'), _jsx('p', {}, void 0, 'Yes! Electronic signatures are federally protected by the ESIGN Act of 2000. They’re also protected on a statewide basis by the UETA Act. Internationally, eSignatures are protected by various acts and legislations. We have customers using HelloSign in Australia, the EU, and more!'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Is it secure to use electronic signatures to sign documents?'), _jsx('p', {}, void 0, 'Yep! It’s absolutely secure as long as you’re working with a verified and secure eSignature provider. HelloSign offers bank-level security to ensure that your information and documents remain protected. This includes:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Hosting in a state-of-the-art SAS70 Type II, SSAE 16 facility that has achieved ISO 27001 certification.'), _jsx('li', {}, void 0, 'A connection that’s encrypted using SSL (Secure Sockets Layer). That’s the same level of security at most leading banks!'), _jsx('li', {}, void 0, 'Documents are stored and encrypted at rest using AES - 256 bit encryption.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'Do I have to electronically sign documents in my HelloSign account?'), _jsx('p', {}, void 0, 'HelloSign integrates with several other companies to make it as easy as possible to sign in whatever app you’re using. Our integration partners include:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Google (including ', _jsx('a', {
            href: 'https://www.hellosign.com/gmail',
            target: '_blank'
        }, void 0, 'Gmail'), ', ', _jsx('a', {
            href: 'https://www.hellosign.com/googledrive',
            target: '_blank'
        }, void 0, 'Google Drive'), ', and ', _jsx('a', {
            href: 'https://www.hellosign.com/google-docs-add-on',
            target: '_blank'
        }, void 0, 'Google Docs'), ')'), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
            target: '_blank'
        }, void 0, 'Evernote')), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/dropbox/',
            target: '_blank'
        }, void 0, 'Dropbox')), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
            target: '_blank'
        }, void 0, 'Slack')), _jsx('li', {}, void 0, 'Zapier'), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
            target: '_blank'
        }, void 0, 'HubSpot CRM'))), _jsx('p', {}, void 0, 'You may be directed to our site to complete the signature, but you can initiate signature requests directly in the integrated apps.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Create an Electronic Signature',
            subtitle: 'See it for yourself! Create your first electronic signature by opening a HelloSign account. You’ll get three signatures a month with our free plan and unlimited signatures with any Pro plan or above.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/how-create-electronic-signature.jsx
 ** module id = 824
 ** module chunks = 0
 **/